<template>
  <div class="clearfix my-2" v-if="societyLogoUrl">
    <b-img left :src="societyLogoUrl" style="max-height: 100px; width: auto;" />
  </div>
</template>

<script>
import { SETTINGS_KEYS } from '@/store';

export default {
  name: 'SocietyLogo',
  props: {
    logoFile: {
      default: null,
      validator: (prop) => typeof prop === 'string' || prop === null,
    },
  },
  computed: {
    societyLogoUrl: function () {
      if (
        this.logoFile &&
        (this.logoFile.startsWith('http') || this.logoFile.startsWith('blob'))
      ) {
        return this.logoFile;
      }
      const storePath = this.$store.getters.getSetting(
        SETTINGS_KEYS.ASSETS_STORE_URL
      );

      if (!this.logoFile || !storePath) {
        return null;
      }
      const mssLogosFolder = this.$store.getters.getSetting(
        SETTINGS_KEYS.S3_LOGO_FOLDER_NAME
      );
      return `${storePath}/${mssLogosFolder}/${this.logoFile}`;
    },
  },
};
</script>

<style scoped></style>
